module.exports = __webpack_public_path__ + "static/media/good-time.c81de9ab.jpg";